require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./frequently-asked-questions.json") })
        }
      }, "path---frequently-asked-questions");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---frequently-asked-questions!./.cache/json/frequently-asked-questions.json
// module id = 2636
// module chunks = 231608221292675